export const CATEGORY_TREE = {
1: { id: 1, name: 'املاک', parent: null },
  2: { id: 2, name: 'اجاره مسکونی', parent: 1 },
  3: { id: 3, name: 'آپارتمان', parent: 2 },
  4: { id: 4, name: 'خانه و ویلا', parent: 2 },
  5: { id: 5, name: 'فروش مسکونی', parent: 1 },
  6: { id: 6, name: 'آپارتمان', parent: 5 },
  7: { id: 7, name: 'خانه و ویلا', parent: 5 },
  8: { id: 8, name: 'زمین و کلنگی', parent: 5 },
  9: { id: 9, name: 'فروش اداری و تجاری', parent: 1 },
  10: { id: 10, name: 'دفتر کار، اتاق اداری و مطب', parent: 9 },
  11: { id: 11, name: 'مغازه و غرفه', parent: 9 },
  12: { id: 12, name: 'صنعتی، کشاورزی و تجاری', parent: 9 },
  13: { id: 13, name: 'اجارهٔ اداری و تجاری', parent: 1 },
  14: { id: 14, name: 'دفتر کار، اتاق اداری و مطب', parent: 13 },
  15: { id: 15, name: 'مغازه و غرفه', parent: 13 },
  16: { id: 16, name: 'صنعتی، کشاورزی و تجاری', parent: 13 },
  17: { id: 17, name: 'اجارهٔ کوتاه مدت', parent: 1 },
  18: { id: 18, name: 'آپارتمان و سوئیت', parent: 17 },
  19: { id: 19, name: 'ویلا و باغ', parent: 17 },
  20: { id: 20, name: 'دفتر کار و فضای آموزشی', parent: 17 },
  21: { id: 21, name: 'پروژه‌های ساخت و ساز', parent: 1 },
  22: { id: 22, name: 'مشارکت در ساخت', parent: 21 },
  23: { id: 23, name: 'پیش‌فروش', parent: 21 },
  24: { id: 24, name: 'وسایل نقلیه', parent: null },
  25: { id: 25, name: 'خودرو', parent: 24 },
  26: { id: 26, name: 'سواری و وانت', parent: 25 },
  27: { id: 27, name: 'کلاسیک', parent: 25 },
  28: { id: 28, name: 'اجاره‌ای', parent: 25 },
  29: { id: 29, name: 'سنگین', parent: 25 },
  30: { id: 30, name: 'قطعات یدکی و لوازم جانبی', parent: 24 },
  31: { id: 31, name: 'موتورسیکلت', parent: 24 },
  32: { id: 32, name: 'قایق و سایر وسایل نقلیه', parent: 24 },
  33: { id: 33, name: 'کالای دیجیتال', parent: null },
  34: { id: 34, name: 'موبایل و تبلت', parent: 33 },
  35: { id: 35, name: 'موبایل', parent: 34 },
  36: { id: 36, name: 'تبلت', parent: 34 },
  37: { id: 37, name: 'لوازم جانبی موبایل و تبلت', parent: 34 },
  38: { id: 38, name: 'سیم‌کارت', parent: 34 },
  39: { id: 39, name: 'رایانه', parent: 33 },
  40: { id: 40, name: 'رایانه همراه', parent: 39 },
  41: { id: 41, name: 'رایانه رومیزی', parent: 39 },
  42: { id: 42, name: 'قطعات و لوازم جانبی', parent: 39 },
  43: { id: 43, name: 'مودم و تجهیزات شبکه', parent: 39 },
  44: { id: 44, name: 'پرینتر، اسکنر، کپی و فکس', parent: 39 },
  45: { id: 45, name: 'کنسول، بازی ویدئویی و آنلاین', parent: 33 },
  46: { id: 46, name: 'صوتی و تصویری', parent: 33 },
  47: { id: 47, name: 'فیلم و موسیقی', parent: 46 },
  48: { id: 48, name: 'دوربین عکاسی و فیلم‌برداری', parent: 46 },
  49: { id: 49, name: 'پخش‌کنندهٔ همراه', parent: 46 },
  50: { id: 50, name: 'سیستم صوتی خانگی', parent: 46 },
  51: { id: 51, name: 'ویدئو و پخش‌ کننده DVD', parent: 46 },
  52: { id: 52, name: 'تلویزیون و پروژکتور', parent: 46 },
  53: { id: 53, name: 'دوربین مداربسته', parent: 46 },
  54: { id: 54, name: 'سایر صوتی و تصویری', parent: 46 },
  55: { id: 55, name: 'تلفن رومیزی', parent: 33 },
  56: { id: 56, name: 'خانه و آشپزخانه', parent: null },
  57: { id: 57, name: 'لوازم خانگی برقی', parent: 56 },
  58: { id: 58, name: 'یخچال و فریزر', parent: 57 },
  59: { id: 59, name: 'آب سرد‌کن و تصفیه', parent: 57 },
  60: { id: 60, name: 'ماشین لباسشویی و خشک‌کن لباس', parent: 57 },
  61: { id: 61, name: 'ماشین ظرفشویی', parent: 57 },
  62: { id: 62, name: 'جاروبرقی، جاروشارژی و بخارشو', parent: 57 },
  63: { id: 63, name: 'اتو و لوازم اتو', parent: 57 },
  64: { id: 64, name: 'آبمیوه و آب‌مرکبات‌گیر', parent: 57 },
  65: { id: 65, name: 'خردکن، آسیاب و غذاساز', parent: 57 },
  66: { id: 66, name: 'سماور، چای‌ساز و قهوه‌ساز', parent: 57 },
  67: { id: 67, name: 'اجاق گاز و لوازم برقی پخت‌وپز', parent: 57 },
  68: { id: 68, name: 'هود', parent: 57 },
  69: { id: 69, name: 'سایر لوازم برقی', parent: 57 },
  70: { id: 70, name: 'ظروف و لوازم آشپزخانه', parent: 56 },
  71: { id: 71, name: 'سفره، حوله و دستمال آشپزخانه', parent: 70 },
  72: { id: 72, name: 'آب‌چکان و نظم‌دهنده ظروف', parent: 70 },
  73: { id: 73, name: 'قوری، کتری و قهوه‌ساز دستی', parent: 70 },
  74: { id: 74, name: 'ظروف سرو و پذیرایی', parent: 70 },
  75: { id: 75, name: 'ظروف نگهدارنده، پلاستیکی و یکبارمصرف', parent: 70 },
  76: { id: 76, name: 'ظروف پخت‌وپز', parent: 70 },
  77: { id: 77, name: 'خوردنی و آشامیدنی', parent: 70 },
  78: { id: 78, name: 'خیاطی و بافتنی', parent: 56 },
  79: { id: 79, name: 'چرخ خیاطی و ریسندگی', parent: 78 },
  80: { id: 80, name: 'لوازم خیاطی و بافتنی', parent: 78 },
  81: { id: 81, name: 'متفرقه', parent: 78 },
  82: { id: 82, name: 'مبلمان و صنایع چوب', parent: 56 },
  83: { id: 83, name: 'مبلمان خانگی و میزعسلی', parent: 82 },
  84: { id: 84, name: 'میز و صندلی غذاخوری', parent: 82 },
  85: { id: 85, name: 'بوفه، ویترین و کنسول', parent: 82 },
  86: { id: 86, name: 'کتابخانه، شلف و قفسه‌های دیواری', parent: 82 },
  87: { id: 87, name: 'جاکفشی، کمد و دراور', parent: 82 },
  88: { id: 88, name: 'تخت و سرویس خواب', parent: 82 },
  89: { id: 89, name: 'میز تلفن', parent: 82 },
  90: { id: 90, name: 'میز تلویزیون', parent: 82 },
  91: { id: 91, name: 'میز تحریر و کامپیوتر', parent: 82 },
  92: { id: 92, name: 'مبلمان اداری', parent: 82 },
  93: { id: 93, name: 'صندلی و نیمکت', parent: 82 },
  94: { id: 94, name: 'نور و روشنایی', parent: 56 },
  95: { id: 95, name: 'لوستر و چراغ‌ آویز', parent: 94 },
  96: { id: 96, name: 'چراغ خواب و آباژور', parent: 94 },
  97: { id: 97, name: 'ریسه و چراغ تزئینی', parent: 94 },
  98: { id: 98, name: 'لامپ و چراغ', parent: 94 },
  99: { id: 99, name: 'فرش، گلیم و موکت', parent: 56 },
  100: { id: 100, name: 'فرش', parent: 99 },
  101: { id: 101, name: 'ورزش و تناسب اندام', parent: null },
  102: { id: 102, name: 'ورزش‌های توپی', parent: 101 },
  103: { id: 103, name: 'پادری', parent: 99 },
  104: { id: 104, name: 'موکت', parent: 99 },
  105: { id: 105, name: 'گلیم، جاجیم و گبه', parent: 99 },
  106: { id: 106, name: 'پشتی', parent: 99 },
  107: { id: 107, name: 'تشک، روتختی و رختخواب', parent: 56 },
  108: { id: 108, name: 'رختخواب، بالش و پتو', parent: 107 },
  109: { id: 109, name: 'تشک تختخواب', parent: 107 },
  110: { id: 110, name: 'سرویس روتختی', parent: 107 },
  111: { id: 111, name: 'لوازم دکوری و تزئینی', parent: 56 },
  112: { id: 112, name: 'پرده، رانر و رومیزی', parent: 111 },
  113: { id: 113, name: 'آینه', parent: 111 },
  114: { id: 114, name: 'سایت دیواری و تزئینی', parent: 111 },
  115: { id: 115, name: 'تابلو، نقاشی و عکس', parent: 111 },
  116: { id: 116, name: 'مجسمه، تندیس و ماکت', parent: 111 },
  117: { id: 117, name: 'گل مصنوعی', parent: 111 },
  118: { id: 118, name: 'گل و گیاه طبیعی', parent: 111 },
  119: { id: 119, name: 'صنایع دستی و سایر لوازم تزئینی', parent: 111 },
  120: { id: 120, name: 'تهویه، سرمایش و گرمایش', parent: 56 },
  121: { id: 121, name: 'آبگرمکن، پکیج و شوفاژ', parent: 120 },
  122: { id: 122, name: 'بخاری، هیتر و شومینه', parent: 120 },
  123: { id: 123, name: 'کولر آبی', parent: 120 },
  124: { id: 124, name: 'کولر گازی و فن‌کوئل', parent: 120 },
  125: { id: 125, name: 'پنکه و تصفیه‌کنندهٔ هوا', parent: 120 },
  126: { id: 126, name: 'شست‌وشو و نظافت', parent: 56 },
  127: { id: 127, name: 'مواد شوینده و دستمال کاغذی', parent: 126 },
  128: { id: 128, name: 'لوازم نظافت', parent: 126 },
  129: { id: 129, name: 'بندرخت و رخت‌آویز', parent: 126 },
  130: { id: 130, name: 'حمام و سرویس بهداشتی', parent: 56 },
  131: { id: 131, name: 'لوازم حمام', parent: 130 },
  132: { id: 132, name: 'لوازم سرویس بهداشتی', parent: 130 },
  133: { id: 133, name: 'خدمات', parent: null },
  134: { id: 134, name: 'موتور و ماشین', parent: 133 },
  135: { id: 135, name: 'پذیرایی و مراسم', parent: 133 },
  136: { id: 136, name: 'خدمات رایانه‌ای و موبایل', parent: 133 },
  137: { id: 137, name: 'مالی، حسابداری و بیمه', parent: 133 },
  138: { id: 138, name: 'حمل و نقل', parent: 133 },
  139: { id: 139, name: 'پیشه و مهارت', parent: 133 },
  140: { id: 140, name: 'آرایشگری و زیبایی', parent: 133 },
  141: { id: 141, name: 'نظافت', parent: 133 },
  142: { id: 142, name: 'باغبانی و درختکاری', parent: 133 },
  143: { id: 143, name: 'آموزشی', parent: 133 },
  144: { id: 144, name: 'وسایل شخصی', parent: null },
  145: { id: 145, name: 'کیف، کفش و لباس', parent: 144 },
  146: { id: 146, name: 'کیف، کفش و کمربند', parent: 145 },
  147: { id: 147, name: 'لباس', parent: 145 },
  148: { id: 148, name: 'زیورآلات و اکسسوری', parent: 144 },
  149: { id: 149, name: 'ساعت', parent: 148 },
  150: { id: 150, name: 'جواهرات', parent: 148 },
  151: { id: 151, name: 'بدلیجات', parent: 148 },
  152: { id: 152, name: 'آرایشی، بهداشتی و درمانی', parent: 144 },
  153: { id: 153, name: 'وسایل بچه و اسباب ‌بازی', parent: 144 },
  154: { id: 154, name: 'کفش و لباس بچه', parent: 153 },
  155: { id: 155, name: 'اسباب بازی', parent: 153 },
  156: { id: 156, name: 'کالسکه و لوازم جانبی', parent: 153 },
  157: { id: 157, name: 'تخت و صندلی بچه', parent: 153 },
  158: { id: 158, name: 'اسباب و اثاث بچه', parent: 153 },
  159: { id: 159, name: 'لوازم التحریر', parent: 144 },
  160: { id: 160, name: 'سرگرمی و فراغت', parent: null },
  161: { id: 161, name: 'بلیط', parent: 160 },
  162: { id: 162, name: 'کنسرت', parent: 161 },
  163: { id: 163, name: 'تئاتر و سینما', parent: 161 },
  164: { id: 164, name: 'کارت هدیه و تخفیف', parent: 161 },
  165: { id: 165, name: 'اماکن و مسابقات ورزشی', parent: 161 },
  166: { id: 166, name: 'ورزشی', parent: 161 },
  167: { id: 167, name: 'اتوبوس، مترو و قطار', parent: 161 },
  168: { id: 168, name: 'تور و چارتر', parent: 160 },
  169: { id: 169, name: 'کتاب و مجله', parent: 160 },
  170: { id: 170, name: 'آموزشی', parent: 169 },
  171: { id: 171, name: 'ادبی', parent: 169 },
  172: { id: 172, name: 'تاریخی', parent: 169 },
  173: { id: 173, name: 'مذهبی', parent: 169 },
  174: { id: 174, name: 'مجلات', parent: 169 },
  175: { id: 175, name: 'دوچرخه، اسکیت و اسکوتر', parent: 160 },
  176: { id: 176, name: 'حیوانات', parent: 160 },
  177: { id: 177, name: 'گربه', parent: 176 },
  178: { id: 178, name: 'موش و خرگوش', parent: 176 },
  179: { id: 179, name: 'خزنده', parent: 176 },
  180: { id: 180, name: 'پرنده', parent: 176 },
  181: { id: 181, name: 'ماهی', parent: 176 },
  182: { id: 182, name: 'لوازم جانبی', parent: 176 },
  183: { id: 183, name: 'حیوانات مزرعه', parent: 176 },
  184: { id: 184, name: 'سگ', parent: 176 },
  185: { id: 185, name: 'کلکسیون و سرگرمی', parent: 160 },
  186: { id: 186, name: 'سکه، تمبر و اسکناس', parent: 185 },
  187: { id: 187, name: 'اشیای عتیقه', parent: 185 },
  188: { id: 188, name: 'آلات موسیقی', parent: 160 },
  189: { id: 189, name: 'گیتار، بیس، و امپلیفایر', parent: 188 },
  190: { id: 190, name: 'سازهای بادی', parent: 188 },
  191: { id: 191, name: 'پیانو، کیبورد و آکاردئون', parent: 188 },
  192: { id: 192, name: 'سنتی', parent: 188 },
  193: { id: 193, name: 'درام و پرکاشن', parent: 188 },
  194: { id: 194, name: 'ویولن', parent: 188 },
  195: { id: 195, name: 'ورزش و تناسب اندام', parent: 160 },
  196: { id: 196, name: 'ورزش‌های توپی', parent: 195 },
  197: { id: 197, name: 'کوهنوردی و کمپینگ', parent: 195 },
  198: { id: 198, name: 'غواصی و ورزش‌های آبی', parent: 195 },
  199: { id: 199, name: 'ماهیگیری', parent: 195 },
  200: { id: 200, name: 'تجهیزات ورزشی', parent: 195 },
  201: { id: 201, name: 'ورزش‌های زمستانی', parent: 195 },
  202: { id: 202, name: 'اسب و تجهیزات اسب سواری', parent: 195 },
  203: { id: 203, name: 'اسباب بازی', parent: 160 },
  204: { id: 204, name: 'اجتماعی', parent: null },
  205: { id: 205, name: 'رویداد', parent: 204 },
  206: { id: 206, name: 'حراج', parent: 205 },
  207: { id: 207, name: 'گردهمایی و همایش', parent: 205 },
  208: { id: 208, name: 'ورزشی', parent: 205 },
  209: { id: 209, name: 'داوطلبانه', parent: 204 },
  210: { id: 210, name: 'تحقیقاتی', parent: 209 },
  211: { id: 211, name: 'گم شده‌ها', parent: 204 },
  212: { id: 212, name: 'حیوانات', parent: 211 },
  213: { id: 213, name: 'اشیا', parent: 211 },
  214: { id: 214, name: 'تجهیزات و صنعتی', parent: null },
  215: { id: 215, name: 'مصالح و تجهیزات ساختمان', parent: 214 },
  216: { id: 216, name: 'ابزارآلات', parent: 214 },
  217: { id: 217, name: 'ماشین آلات صنعتی', parent: 214 },
  218: { id: 218, name: 'تجهیزات کسب‌وکار', parent: 214 },
  219: { id: 219, name: 'پزشکی', parent: 218 },
  220: { id: 220, name: 'فروشگاه و مغازه', parent: 218 },
  221: { id: 221, name: 'کافی شاپ و رستوران', parent: 218 },
  222: { id: 222, name: 'آرایشگاه و سالن‌های زیبایی', parent: 218 },
  223: { id: 223, name: 'دفترکار', parent: 218 },
  224: { id: 224, name: 'عمده فروشی', parent: 214 },
};


export function getCategoryPath(id, sep = ' > ') {
  const path = [];
  let current = CATEGORY_TREE[id];
  while (current) {
    path.unshift(current.name);
    current = current.parent ? CATEGORY_TREE[current.parent] : null;
  }
  return path.length ? path.join(sep) : '';
}
